import * as React from "react";
import {
  Grid,
  Box,
  Stack,
  Typography,
  Button,
  alpha,
  IconButton,
  Chip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AppNavbar from "../Components/AppNavbar";
import Search from "../Components/Search";
import ColorModeIconDropdown from "../theme/ColorModeIconDropdown";
import Copyright from "../Components/Copyright";
import { ApiManager } from "../Services/Networking";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Edit, Trash } from "lucide-react";

import { Tooltip } from "@mui/material";
import Layout from "../Components/Layout";

export default function Department() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchText, setSearchText] = useState("");
  const [departments, setDepartments] = useState(
    location.state?.updatedList || [],
  );
  const [loading, setLoading] = useState(!location.state?.updatedList);

  useEffect(() => {
    if (!location.state?.updatedList) {
      fetchData();
    }
  }, [location.state?.updatedList]);

  const fetchData = async () => {
    setLoading(true);
    const res = await ApiManager.getEmployeeDepartments();
    if (res.status === "success") {
      const grouped = res.data.reduce((acc, curr) => {
        const existing = acc.find((item) => item.dept_id === curr.dept_id);
        const empData = curr.emp_id
          ? { id: curr.emp_id, name: curr.emp_name }
          : null;

        if (existing) {
          if (empData) existing.employees.push(empData);
        } else {
          acc.push({
            ...curr,
            employees: empData ? [empData] : [],
          });
        }
        return acc;
      }, []);
      setDepartments(grouped);
    }
    setLoading(false);
  };

  const deleteDept = async (id) => {
    if (window.confirm("Are you sure?")) {
      setLoading(true);
      const res = await ApiManager.deleteDepartment(id);
      if (res.status === "success") {
        setDepartments((prev) => prev.filter((d) => d.dept_id !== id));
      }
      setLoading(false);
    }
  };

  const columns = [
    { field: "dept_id", headerName: "ID", width: 80 },
    { field: "dept_name", headerName: "Department Name", flex: 1 },
    {
      field: "employees",
      headerName: "Employees",
      flex: 2,
      renderCell: (params) => (
        <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ py: 1 }}>
          {params.value.length > 0 ? (
            params.value.map((emp) => (
              <Tooltip key={emp.id} title={emp.name} arrow>
                <Chip label={emp.id} size="small" variant="outlined" />
              </Tooltip>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No Employees
            </Typography>
          )}
        </Stack>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <Stack direction="row" spacing={1} alignItems="center" height="100%">
          <IconButton
            onClick={() =>
              navigate("/department/form", {
                state: { dept: params.row, fullList: departments },
              })
            }
          >
            <Edit size={18} />
          </IconButton>
          <IconButton onClick={() => deleteDept(params.row.dept_id)}>
            <Trash size={18} />
          </IconButton>
        </Stack>
      ),
    },
  ];

  const filteredRows = departments.filter((row) =>
    row.dept_name.toLowerCase().includes(searchText.toLowerCase()),
  );

  return (
    <Layout name="DEPARTMENTS">
      <Box sx={{ width: "100%", maxWidth: "1700px" }}>
        <Stack direction="row" spacing={2} mb={2}>
          <Search
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <Box sx={{ flexGrow: 1 }} />
          <Button
            variant="contained"
            onClick={() =>
              navigate("/department/form", {
                state: { dept: null, fullList: departments },
              })
            }
          >
            Create New
          </Button>
        </Stack>
        <Box sx={{ height: 600 }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            loading={loading}
            getRowId={(row, ind) => `${row.dept_id} ${ind}`}
            disableRowSelectionOnClick
          />
        </Box>
      </Box>
    </Layout>
  );
}
